import { render, staticRenderFns } from "./view.vue?vue&type=template&id=72791a71&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=72791a71&prod&scoped=true&lang=css&"
import style1 from "./view.vue?vue&type=style&index=1&id=72791a71&prod&lang=scss&scoped=true&"
import style2 from "./view.vue?vue&type=style&index=2&id=72791a71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72791a71",
  null
  
)

export default component.exports